<template>
  <!-- 导入订单数据弹窗 -->
  <el-dialog
    v-el-drag-dialog
    :title="$t('SeaExport.BoxListRecognition')"
    :visible.sync="innerVisible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    width="678px"
    class="box-list-recognition-dialog"
  >
    <div class="upload-area">
      <!-- 初始上传界面 -->
      <div v-if="step === 1" class="drop-area">
        <div class="drop-info">
          <el-upload
            ref="upload"
            class="el-upload-body"
            style="text-align: center"
            :action="URL.common.uploadStorage"
            :headers="headers"
            :data="uploadParams"
            :auto-upload="false"
            :multiple="true"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-change="handleChange"
            :on-success="uploadSuccess"
            :on-error="uploadFaild"
            drag
            accept=".pdf,.jpg,.jpeg,.png,.gif,.txt,.xls,.xlsx,.doc,.docx"
          >
            <img src="@/assets/icons/ai-recognition-folder.png" class="drop-icon-large" alt="">
            <div class="el-upload__text">
              {{ $t('SeaExport.DragOrClick') }}<em>{{ $t('SeaExport.ClickUpload') }}</em>
            </div>
            <div slot="tip" class="el-upload__tip">
              {{ $t('SeaExport.SupportingUploadFormat') }}
            </div>
          </el-upload>
        </div>
      </div>

      <!-- 上传进度界面 -->
      <div v-if="step === 2" class="progress-area">
        <div style="text-align: center;margin-top: 10px">
          <img src="@/assets/icons/ai-recognition-pdf.png" alt="">
          <p>{{ $t('SeaExport.RecognitionInProgress') }}</p>
          <el-progress
            type="line"
            :show-text="false"
            :percentage="uploadProgress"
          />
        </div>
      </div>

      <div v-show="fileList.length > 0">
        <p style="font-size: 18px;">{{ $t('SeaExport.UploadedFile') }}</p>
        <el-table :data="fileList" :show-header="false" height="185px" style="border:1px;">
          <el-table-column label="" width="450px">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button v-show="step === 1" type="text" style="color: red;" @click="removeFile(scope.row)">{{ $t('SeaExport.Remove') }}</el-button>
              <el-button v-show="step === 2 && scope.row.analysisId" type="text" style="color: red;" @click="deleteFile(scope.row)">{{ $t('SeaExport.Delete') }}</el-button>
              <el-button v-show="step === 2 && scope.row.analysisId" type="text">{{ $t('SeaExport.Parsing') }}</el-button>
              <el-button v-show="scope.row.analysisId && scope.row.analysisState === 1" type="text">{{ $t('SeaExport.ParsingComplete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="ai-recognition-warn">
        <img src="@/assets/icons/ai-recognition-bell.png" alt="">
        <p>{{ $t('SeaExport.AiRecognitionWarn') }}</p>
      </div>
    </div>

    <span slot="footer" class="button-dialog-footer">
      <el-button
        size="medium"
        :plain="true"
        style="width: 110px; height: 40px; margin-right: 19px;"
        @click="innerVisible = false"
      >{{ $t('SeaExport.Cancel') }}</el-button>
      <el-button size="medium" type="primary" :disabled="step !== 1" style="width: 110px; height: 40px" @click="startRecognitionHandler">{{
        $t('SeaExport.StartRecognition')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import {
  getAnalysis, getChannelConfigUrlFunc,
  importAndAnalyseFile,
  removeIntelligentDocument
} from '@/api/seaExport/intelligentBooking'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import URL from '@/api/urlTranslator'
import {
  IDENTIFY_TYPE_7,
  INTELLIGENT_DOCUMENT_SOURCE_17, TYPE_BOX_LIST
} from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { checkBsItemOpened } from '@/api/booking/job'

export default {
  name: 'BoxListRecognitionDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    job: {
      type: Object,
      default: { },
      required: true
    },
    userInfo: {
      type: Object,
      default: { },
      required: true
    }
  },
  data() {
    return {
      step: 1,
      currentFile: {},
      innerVisible: this.visible,
      fileList: [],
      URL,
      uploadProgress: 0,
      progressTimer: null, // 添加进度条定时器引用
      analyseTimer: null, // 轮询查询解析状态
      analyseCount: 0, // 轮询查询解析次数
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      bsState: -1, //  -1 未开通计费项目 -2 余额不足
      channelOpen: false // 是否开通对应项目
    }
  },
  computed: {
    uploadParams() {
      return {
        jobNo: this.job.jobNo,
        mbl: this.job.mbl,
        uuid: this.job.uuid,
        createdBy: this.userInfo.userId,
        createChineseName: this.userInfo.chineseName,
        createEnglishName: this.userInfo.englishName,
        documentType: 'other',
        documentName: 'other',
        isShared: false,
        op: false,
        sales: false,
        cargoSales: false,
        csr: false,
        overseaOp: false,
        dc: false,
        planner: false,
        userDefinedRoleId1: false,
        userDefinedRoleId2: false,
        all: false,
        customer: false,
        consignee: false,
        shipper: false,
        destinationAgent: false,
        bookingAgent: false,
        fileSource: ChargeItemTarget.UPLOAD.code
      }
    }
  },
  watch: {
    visible(val) {
      this.init(val)
    },
    innerVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    async init(val) {
      this.innerVisible = val
      // 判断是否需要清空
      for (const file of this.fileList) {
        if (!file.analysisId) {
          this.fileList = []
          this.clearFiles()
          break
        }
      }
      const isOk = await this.checkAnalysis()
      if (isOk) {
        this.step = 1
        this.currentFile = null
        this.uploadProgress = 0
        this.analyseCount = 0
        this.fileList = []
        this.clearFiles()
      }
      if (val) {
        await this.queryBs()
      }
    },
    clearFiles() {
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles()
      }
    },
    beforeUpload(file) {
      const isValidType = ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.txt', '.xls', '.xlsx', '.doc', '.docx'].some(type =>
        file.name.toLowerCase().endsWith(type)
      )
      const isLt4M = file.size / 1024 / 1024 < 4

      if (!isValidType) {
        this.$message.error(this.$t('SeaExport.InvalidFileType'))
      }
      if (!isLt4M) {
        this.$message.error(this.$t('SeaExport.FileTooLarge'))
      }
      this.currentFile = file
    },
    // 上传文件修改
    handleChange(file, files) {
      const fileList = []
      for (const item of files) {
        if (!item.status) {
          item.status = 0
        }
        fileList.push(item)
      }
      this.fileList = fileList
    },
    // 上传成功
    uploadSuccess(res) {
      if (res.ok && res.data) {
        this.currentFile.fileId = res.data
        this.$message.success(this.$t('SeaExport.UploadSuccess'))
      }
    },
    // 上传失败
    uploadFaild() {
      this.$message.error(this.$t('SeaExport.UploadFailed'))
    },
    // 开始识别
    async startRecognitionHandler() {
      const regex = /[;'"#$&+?]/g
      for (const file of this.fileList) {
        if (file.name.match(regex)) {
          this.$message.warning(this.$t('SeaExport.SpecialCharactersNotAllow'))
          return
        }
      }
      if (!this.channelOpen) {
        this.$message.warning(this.$t('CargoMsg.Cargo_IdentificationCannotBePerformedTip'))
        return
      }
      if (!this.bsState || this.bsState === -1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_UnopenedService'))
        return
      } else if (this.bsState === -2) {
        this.$message.warning(this.$t('CargoMsg.Cargo_RemainingAmountNotEnough'))
        return
      }
      if (!this.fileList || this.fileList.length === 0) {
        return
      }
      this.step = 2
      this.startProgressAnimation(0, 30, 2000)
      for (const file of this.fileList) {
        // 调用识别接口处理
        const formData = new FormData()
        formData.append('file', file.raw)
        formData.append('source', INTELLIGENT_DOCUMENT_SOURCE_17.code)
        formData.append('iChannel', IDENTIFY_TYPE_7.code)
        formData.append('jobUuid', this.job.uuid)
        formData.append('pageSource', 'ocr')
        formData.append('officeId', this.$store.getters.currentOfficeId)
        await importAndAnalyseFile(formData).then((res) => {
          if (res.ok) {
            file.analysisId = res.data
          }
        })
      }
      this.fileList = [...this.fileList]
      // 调用定时器轮询查是否解析完成
      await this.startAnalysisFile()
    },
    // 12秒查询一次解析状态 若超过10次(两分钟)查询仍然没成功，则中断
    async startAnalysisFile() {
      this.analyseTimer = setInterval(async() => {
        const isOk = await this.checkAnalysis()

        // 若进度条超过80且仍然没解析成功，则不继续增加
        if (this.uploadProgress < 80) {
          this.uploadProgress += 10
        }
        this.analyseCount++
        if (isOk) {
          this.uploadProgress = 100
          clearInterval(this.analyseTimer)
          // 将解析结果写入业务
          this.handleResult()
        } else if (this.analyseCount >= 10) {
          // 超过两分钟没解析成功，则打断定时器
          this.uploadProgress = 100
          clearInterval(this.analyseTimer)
        }
      }, 12000)
    },
    // 检查是否全部解析完成
    async checkAnalysis() {
      let isOk = true
      const fileList = this.fileList
      for (const file of fileList) {
        if (file.analysisState && file.analysisState === 1) {
          continue
        }
        const result = await getAnalysis(file.analysisId).then(res => res.data)
        if (result) {
          file.analysisState = 1
        } else {
          isOk = false
        }
      }
      this.fileList = fileList
      return isOk
    },
    // 新增进度条动画控制方法
    async startProgressAnimation(startValue, endValue, duration) {
      // 清除之前的定时器
      if (this.progressTimer) {
        clearInterval(this.progressTimer)
      }
      const interval = setInterval(() => {
        if (this.uploadProgress < endValue) {
          this.uploadProgress += 10
        } else {
          clearInterval(interval)
        }
      }, duration / ((endValue - startValue) / 10))
      this.progressTimer = interval // 保存定时器引用
      return interval
    },
    // 移除文件
    removeFile(file) {
      const fileList = []
      for (const item of this.fileList) {
        if (item.name !== file.name) {
          fileList.push(item)
        }
      }
      this.fileList = fileList
      if (fileList.length === 0) {
        this.step = 1
      }
      if (this.$refs.upload) {
        this.$refs.upload.handleRemove(file)
      }
    },
    // 删除文件
    deleteFile(file) {
      this.$confirm(this.$t('SeaExport.AreYouWantToDelete'), this.$t('SeaExport.Tips'), {}).then(() => {
        removeIntelligentDocument(file.analysisId).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.removeFile(file)
        })
      })
    },
    // 处理解析结果
    handleResult() {
      this.analyseCount = 0
      this.fileList = []
      this.innerVisible = false
      this.$emit('refresh')
    },
    async queryBs() {
      // 查询计费系统是否开通托书
      const loading = getLoading4Cxt()
      try {
        await checkBsItemOpened(TYPE_BOX_LIST).then(res => {
          this.bsState = res.data // 0 不存在对应通道 -1 未开通计费 -2 余额不足 其他开通且充足
        })
        await getChannelConfigUrlFunc().then(res => {
          if (res.data && res.data.boxListChannel) {
            this.channelOpen = true
          }
        })
      } finally {
        loading.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box-list-recognition-dialog {
  font-size: 16px;

  ::v-deep .el-dialog {
    .el-dialog__header {
      padding: 0;
      border-bottom: none;
    }

    .el-dialog__title {
      color: #000000;
      margin-left: 27px;
      margin-top: 20px;
    }

    .el-dialog__footer {
      padding-top: 0;
      padding-bottom: 23px;
      border: none;
      margin-right: 15px;
    }
  }

  .upload-area {
    color: #000000;
    display: flex; /* 使用 Flexbox 布局 */
    flex-direction: column; /* 垂直排列子元素 */
    margin-left: 15px;

    .drop-area,
    .preview-area,
    .progress-area {
      border: 1px solid #D3D3D3;
      border-radius: 6px;
      background-color: #F7F7F7;
      width: 629px;
      height: 218px;
      display: flex;
      justify-content: center; /* 水平居中 */
    }
    .drop-area {
      .drop-info {
        margin-top: 20px;
      }

      &:hover {
        border-color: #409EFF;
      }

      .drop-icon-large {
        width: 90px;
        height: 90px;
      }

      ::v-deep .el-upload-body .el-upload-dragger {
        height: 140px;
        border: none;
        background-color: #F7F7F7;
      }

      .el-upload__text {
        font-size: 16px;
        color: #000000;
      }

      .el-upload__text em {
        font-size: 16px;
      }

      .el-upload__tip {
        font-size: 16px;
        margin-top: 0;
      }
    }

    .ai-recognition-warn {
      display: flex; /* 使用 Flexbox 布局 */
      align-items: center; /* 垂直居中对齐 */
      background-color: #FCF1DF;
      height: 27px;
      width: 628px;
    }

    .ai-recognition-warn img {
      margin-right: 8px;
      margin-left: 8px;
    }

    .ai-recognition-warn p {
      font-size: 14px;
      color: #F09737;
      padding-top: 5px;
      margin: 0; /* 移除默认的外边距 */
      text-align: left; /* 左对齐文本 */
    }

    .button-dialog-footer {
      margin-right: 30px;
      margin-bottom: 30px;

      ::v-deep .el-button .el-button--default .el-button--medium .is-plain {
        width: 110px;
        height: 40px;
      }

    }
  }
}
</style>
